import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import ComponentInfo from "./component-details/component-details-form";
import LastProcessorInfo from "./component-details/product-components";
import RawMaterialInfo from "./component-details/raw-material-info";
import { StyledButton } from "../../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../../shared/components/table/custom-actions";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../../shared/components/stepper/steppers";
import {
  TCComponentData,
  TCComponentInformation,
  TCComponentRawMaterialInformation,
  TCComponentCertifiedWeightInformation,
} from "../../../tc-models/tc-req-dto/tc-component-details.req_dto";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../../shared/components/buttons/floating-button-container";
import ProductComponent from "./component-details/product-components";
import {
  mapJsonToPayload,
  payloadToJsonMap,
} from "../../payload/component-details-payload";

import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useFormActions } from "../../../../../../shared/hooks/form-builder.hooks";
import useNotification from "../../../../../../shared/hooks/useNotification";
import { useApi } from "../../../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../../../shared/components/loaders/page-loader";
import {
  DELETECONFIG,
  TC_CREATE_ROUTE_CONFIG,
  TCAppConfig,
} from "../../../../../../shared/app-configs/tc-app-configs";
import _ from "lodash";
import AlertPopup from "../../../../../../shared/components/modals/alert-moadal";
import { useTransactionCertificateStore } from "../../../../../../store/transaction-certificates.store";
import { Utills } from "../../../../../../shared/app-configs/utilit";
import RenderDetailPanel from "./render-detail-panel";
import {
  ApiGetComponentList,
  Component,
  getProductShipmentDataByProductNo,
  MappedComponentPayload,
  mapToApiComponentData,
} from "./component-details.model";
import { ApiShipmentResponseItem } from "../shipments/shipments.model";
import {
  fetchaddComponentDetails,
  mapComponentData,
} from "./component-details-apis";
import {
  getShipmentIdsByNumbers,
  ProductShipmentResponse,
} from "../certified-products/certified-products.model";
// Initial State Definitions
const initComponentInfo: TCComponentInformation = {
  tcProductComponentOrder: "",
  tcAssociatedProductNo: "",
  tcProductComponentNo: "",
  tcProductComponentDetail: "",
  tcProductComponentInfoTrimsExcluded: "",
  tcProductComponentInfoAssociatedTc: "",
  tcProductComponentInfoFiberLength: "",
  tcProductComponentInfoYarnCount: "",
  tcProductComponentInfoFabricWeightAndConstruct: "",
  tcProductComponentInfoFabricWeightOfFinishedProduct: "",
  tcProductComponentNetShippingWeight: 0,
  tcProductComponentSupplementaryWeight: 0,
  tcProductComponentInfoAdditional: "",
  tcProductComponentInfoTechnicalSpecifications: ""
};
const initStandardInfo: TCComponentCertifiedWeightInformation[] = [];

const initRawMaterialInfo: TCComponentRawMaterialInformation[] = [];

interface TcComponentDetailsInfoProps {
  onNextTab: () => Promise<void>;
}

const ComponentDetails: React.FC<TcComponentDetailsInfoProps> = ({
  onNextTab,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [editingIndex, setEditingIndex] = useState<number>(-1);
  const { notify } = useNotification();
  const [stepData, setStepData] = useState({
    componentInfo: initComponentInfo,
    standardInfo: initStandardInfo,
    rawMaterialInfo: initRawMaterialInfo,
  });
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const {
    getCurrentTableData,
    updateTableData,
    removeTableRowbyIndex,
    updateField,
    setDeleteSave,
    resetFormValueByPage,
  } = useFormActions("component-details");
  const { TE_ID, formtype } = useParams<string>();
  const [data, setData] = useState<any[]>([]);
  const { loading, executeGet, setLoadingState, executePost, executeDelete } =
    useApi();
  // Refs for Form Steps
  const { executeGet: executeaddGet } = useApi();
  const componentInfoRef = useRef<any>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [apiData, setAPIData] = useState<[]>([]);
  const [pendingSave, setPendingSave] = useState<any | null>(null);
  const [originalValue, setOriginalValue] = useState("");
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const hasCreateTc: boolean = formtype === "create-tc";
  const hasSubmitTc: boolean = formtype === "submited-tc";
  const hasRejectedTc: boolean = formtype === "rejected-tc";
  const [isDeleteOnly, setIsDeleteOnly] = useState(false);
  const [productData, setProductData] = useState<ProductShipmentResponse[]>([]);
  const [tableData, setTableData] = useState<ApiGetComponentList>([]);
  const [productRawMaterialCodes, setProductRawMaterialCodes] = useState<string[]>([]);
  const [productId, setProductId] = useState<string | null>(null);
  const [shipmentId, setShipmentId] = useState<string | null>(null);
  const [componentId, setComponentId] = useState<string | null>(null);
  const [tcProductComponentNo, setTcProductNo] = useState<string | null | undefined>(
    null
  );
  const { executeGet: executeShipment } = useApi();
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [isValueChanged, setIsValueChanged] = useState<boolean>(false);
  const [isCopy, setIsCopy] = useState(false);
  const [originalProductArticleNo, setOriginalProductArticleNo] = useState<string | null>(null);
  const [isRawMaterialValid, setIsRawMaterialValid] = useState<boolean>(false);
  const [hasWeightValidationError, setHasWeightValidationError] = useState<boolean>(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [certifiedRawMaterialCodes, setCertifiedRawMaterialCodes] = useState<any[]>([]);
  const [tcStandardList, setTcStandardList] = useState<string[]>([]);

  const validateNetWeightViaAPI = async (values: TCComponentInformation, productData: any) => {
    const articleNo = values.tcAssociatedProductNo;
    if (!articleNo) {
      return { valid: true, msg: "" };
    }

    const products = Array.isArray(productData) ? productData : (productData?.response || []);
    const selectedProduct = products.find((p: any) => p.tcProductArticleNo === articleNo);
    if (!selectedProduct) {
      return { valid: true, msg: "" };
    }

    const enteredValue = values.tcProductComponentNetShippingWeight;
    const enteredNum = enteredValue !== null && enteredValue !== undefined ? Number(enteredValue) : null;
    const componentNo = values.tcProductComponentNo?.toLowerCase().trim();
    const isNotNa = componentNo !== "na";

    // If Component No is "na" and no weight entered, skip validation
    if (!isNotNa && (enteredNum === null || enteredNum === undefined || enteredNum === 0)) {
      return { valid: true, msg: "" };
    }

    // If Component No is not "na" and no weight entered, it's required
    if (isNotNa && (enteredNum === null || enteredNum === undefined || enteredNum === 0)) {
      return { valid: false, msg: "Net Shipping Weight is required when Component No is not 'na'." };
    }

    // Use already-fetched product info to validate against available weight
    const netShippingWeight = Number(
      selectedProduct.tcProductNetShippingWeight ?? selectedProduct.tcNetShippingWeight ?? 0
    );
    const supplementaryWeight = Number(
      selectedProduct.tcProductSupplementaryWeight ?? selectedProduct.tcSupplementaryWeight ?? 0
    );

    if (Number.isNaN(netShippingWeight) || Number.isNaN(supplementaryWeight)) {
      console.warn("Unable to validate weight - product weight data missing", selectedProduct);
      return { valid: true, msg: "" };
    }

    const availableWeight = Math.max(0, netShippingWeight - supplementaryWeight);

    if (enteredNum !== null && enteredNum > availableWeight) {
      const formattedAvailable = Number.isFinite(availableWeight)
        ? availableWeight.toString()
        : "the available limit";
      return {
        valid: false,
        msg: `Net Shipping Weight exceeds available weight (${formattedAvailable}).`,
      };
    }

    return { valid: true, msg: "" };
  };

  const resetDrawerState = () => {
    setStepData({
      componentInfo: initComponentInfo,
      standardInfo: initStandardInfo,
      rawMaterialInfo: initRawMaterialInfo,
    });
    setProductId(null);
    setShipmentId(null);
    setComponentId(null);
    setEditingIndex(-1);
    setPendingSave(null);
    setIsValueChanged(false);
    setIsCopy(false);
    setIsEdit(false);
    setOriginalProductArticleNo(null);
    setTcProductNo(null);
    setIsDeleteOnly(false);
    setHasWeightValidationError(false);
  };

  const toggleDrawer = () => {
    setActiveStep(0);
    if (drawerOpen) {
      setIsEdit(false);
      resetDrawerState();
    }
    setDrawerOpen((prev) => !prev);
    setRestrictPopUpSave(false);
  };


  const { isRestrictPopUpSave, setRestrictPopUpSave } =
    useTransactionCertificateStore();
  const shipmentFormData = async () => {
    try {
      const response = await executeShipment(
        TCAppConfig.GET_LIST_PRODUCT_INFO_V4,
        { tcId: TE_ID }
      );
      // Extract the response array from the API response
      const productList = response?.data?.response || response?.data || [];
      setProductData(productList);
      console.log("Product data fetched:", productList);
    } catch (err) {
      console.error("Failed to fetch TC Base Information:", err);
    }
  };

  const handleDataUpdate = (stepKey: string, updatedData: any) => {
    setStepData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };

  const fetchComponentDetails = async () => {
    try {
      const offset = pagination.pageIndex * pagination.pageSize;
      const response: any = await executeGet(
        TCAppConfig.GET_COMPONENT_DETAILS_LIST_V4,
        { tcId: TE_ID, limit: pagination.pageSize, offset }
      );
      const result = response.data;
      const componentList = Array.isArray(result?.response) ? result.response : [];
      console.log(componentList);
      setTableData(componentList);
      setAPIData(componentList);
      setRowCount(result?.no_of_records || 0);
      setDeleteSave(false);
      setNextEnabled(true);
    } catch (err) {
      console.error("Failed to fetch TC Base Information:", err);
      // Ensure tableData is always an array even on error
      setTableData([]);
      setAPIData([]);
      setRowCount(0);
    }
  };

  const setZustandInitialState = (initialState?: any) => {
    // //alert(initialState)
    const defalutState: any = {
      tcProductComponentOrder: "",
      tcProductComponentNo: "",
      tcProductComponentDetail: "",
      tcAssociatedProductNo: "",
      tcProductComponentInfoTrimsExcluded: "",
      tcProductComponentInfoAssociatedTc: "",
      tcProductComponentInfoFiberLength: 0,
      tcProductComponentInfoYarnCount: 0,
      tcProductComponentInfoFabricWeightAndConstruct: 0,
      tcProductComponentInfoFabricWeightOfFinishedProduct: 0,
      tcProductComponentNetShippingWeight: 0,
      tcProductComponentSupplementaryWeight: 0,
      tcProductComponentInfoAdditional: 0,
      "standard-info": [],
      "raw-materials-info": [],
    };
    //set zustand state inital values
    Object.entries(initialState ?? defalutState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };

  // Refs to prevent multiple API calls
  const executeGetRef = useRef(executeGet);
  const hasFetchedCertifiedDataRef = useRef<boolean>(false);
  const lastTeIdRef = useRef<string>("");

  // Update ref when executeGet changes
  useEffect(() => {
    executeGetRef.current = executeGet;
  }, [executeGet]);

  // Fetch certified RM codes and TC standards for validation - only once per TE_ID
  useEffect(() => {
    if (!TE_ID) {
      hasFetchedCertifiedDataRef.current = false;
      lastTeIdRef.current = "";
      setCertifiedRawMaterialCodes([]);
      setTcStandardList([]);
      return;
    }

    // Skip if we've already fetched for this TE_ID
    if (hasFetchedCertifiedDataRef.current && lastTeIdRef.current === TE_ID) {
      return;
    }

    const fetchCertifiedData = async () => {
      try {
        hasFetchedCertifiedDataRef.current = true;
        lastTeIdRef.current = TE_ID;
        
        const [rmRes, baseRes] = await Promise.all([
          executeGetRef.current(TCAppConfig.GET_CERTIFIED_RAW_MATERIAL_CODES),
          executeGetRef.current(TCAppConfig.GET_TC_BASE_DETAILS_V4, { tcId: TE_ID }),
        ]);
        
        const rmList = rmRes?.data?.response || rmRes?.data || [];
        setCertifiedRawMaterialCodes(Array.isArray(rmList) ? rmList : []);
        
        const standards = baseRes?.data?.tcStandard || [];
        setTcStandardList(Array.isArray(standards) ? standards : []);
      } catch (err) {
        console.error("Failed to fetch certified RM codes or TC standards:", err);
        hasFetchedCertifiedDataRef.current = false; // Reset on error to allow retry
        lastTeIdRef.current = "";
      }
    };
    fetchCertifiedData();
  }, [TE_ID]);

  useEffect(() => {
    // setZustandInitialState(null)
    // const componentDetailsData = getCurrentTableData()
    // Utills.cl(`componentDetailsData ${componentDetailsData}`)
    // if (componentDetailsData) {
    //   setData(componentDetailsData)
    // }
    if (TE_ID) {
      fetchComponentDetails();
      shipmentFormData();
    } else {
      // TO DO Port Changes 4
      updateTableData([]);
    }
    // TO DO Port Changes 5
    resetFormValueByPage();
    setZustandInitialState();
    setRestrictPopUpSave(false);
  }, [TE_ID, pagination?.pageIndex]);

  const steps = [
    {
      label: "Component Information",
      content: (
        <ComponentInfo
          formRef={componentInfoRef}
          componentData={stepData.componentInfo}
          setComponentData={(data) => handleDataUpdate("componentInfo", data)}
          productData={productData || []}
          onProductRawMaterialCodesChange={React.useCallback((codes: string[]) => setProductRawMaterialCodes(codes), [])}
        />
      ),
    },
    {
      label: "Component Raw Material Info",
      content: (
        <RawMaterialInfo
          rawMaterialInfoData={stepData.rawMaterialInfo}
          setRawMaterialInfoData={(data) => {
            handleDataUpdate("rawMaterialInfo", data);
          }}
          onValidationChange={(isValid) => setIsRawMaterialValid(isValid)}
          componentNo={stepData.componentInfo?.tcProductComponentNo}
          productRawMaterialCodes={productRawMaterialCodes}
          certifiedRawMaterialCodes={certifiedRawMaterialCodes}
          tcStandardList={tcStandardList}
        />
      ),
    },
    {
      label: "Component Certified Weight Info",
      content: (
        <ProductComponent
          productInfoData={stepData.standardInfo}
          setProductInfoData={(data) => handleDataUpdate("standardInfo", data)}
          componentNo={stepData.componentInfo?.tcProductComponentNo}
          associatedProductNo={stepData.componentInfo?.tcAssociatedProductNo}
          productData={productData}
          rawMaterialInfoData={stepData.rawMaterialInfo}
          componentNetShippingWeight={stepData.componentInfo?.tcProductComponentNetShippingWeight}
          certifiedRawMaterialCodes={certifiedRawMaterialCodes}
          tcStandardList={tcStandardList}
        />
      ),
    },
  ];

  const handleStepChange = (newStep: number) => {
    // Prevent navigation from step 0 to step 1+ if weight validation has failed
    if (activeStep === 0 && newStep > 0 && hasWeightValidationError) {
      notify("Please fix the weight validation error before proceeding to the next step.", "error");
      return;
    }
    setActiveStep(newStep);
    setRestrictPopUpSave(false);
  };

  const handleNext = async () => {
    if (activeStep === 0) {
      if (componentInfoRef?.current) {
        const formik = componentInfoRef.current;
        const errors = await formik.validateForm();
        Object.keys(errors).forEach((fieldName) => {
          formik.setFieldTouched(fieldName, true, false);
        });
        if (Object.keys(errors).length === 0) {
          const values = formik.values as TCComponentInformation;
          const { valid, msg } = await validateNetWeightViaAPI(values, productData);
          console.log("Weight validation result:", { valid, msg });
          if (!valid) {
            console.log("Weight validation failed, preventing navigation");
            formik.setFieldError("tcProductComponentNetShippingWeight", msg);
            notify(msg, "error");
            setHasWeightValidationError(true);
            return;
          }
          // Only update data and advance if weight validation passes
          console.log("Weight validation passed, updating component data and advancing");
          handleDataUpdate("componentInfo", values);
          setHasWeightValidationError(false);
          setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
        } else {
          notify("Please fill in all required fields correctly", "error");
        }
      } else {
        notify("Form is not ready. Please wait.", "error");
      }
    } else if (activeStep === 1) {
      // Validate raw material info based on component number
      const componentNo = stepData.componentInfo?.tcProductComponentNo?.toLowerCase().trim();
      const isComponentNotNa = componentNo && componentNo !== "na";

      // If component number is not "na", at least one row with code and percentage is required
      if (isComponentNotNa) {
        const hasValidRow = stepData.rawMaterialInfo.some(
          item => item.tcProductComponentRawMaterialCode && (item.tcProductComponentRawMaterialPercentage ?? 0) > 0
        );

        if (!hasValidRow) {
          notify("At least one raw material with code and percentage is required when Component Number is not 'na'", "error");
          return;
        }
      }

      // Validate raw material percentages
      const rawMaterialData = stepData.rawMaterialInfo;
      const total = rawMaterialData.reduce((sum, item) => {
        if (item.tcProductComponentRawMaterialCode || (item.tcProductComponentRawMaterialPercentage ?? 0) > 0) {
          return sum + (item.tcProductComponentRawMaterialPercentage || 0);
        }
        return sum;
      }, 0);

      // Check if total exceeds 100%
      if (total > 100) {
        notify("Raw material percentages cannot exceed 100%. Current total: " + total.toFixed(2) + "%", "error");
        return;
      }

      // Check if there are any raw materials entered but total is less than 100%
      const hasRawMaterialsEntered = rawMaterialData.some(
        item => item.tcProductComponentRawMaterialCode || (item.tcProductComponentRawMaterialPercentage ?? 0) > 0
      );

      if (hasRawMaterialsEntered && total < 100) {
        notify("Raw material percentages must total 100%. Current total: " + total.toFixed(2) + "%", "error");
        return;
      }

      // All validations passed, proceed to next step
      setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    } else {
      // For step 2 - Validate certified weight info based on component number
      const componentNo = stepData.componentInfo?.tcProductComponentNo?.toLowerCase().trim();
      const isComponentNotNa = componentNo && componentNo !== "na";

      if (isComponentNotNa) {
        const hasValidRow = stepData.standardInfo.some(
          item => item.tcProductComponentClaimsCategory && (item.tcProductComponentCertifiedWeight ?? 0) > 0
        );

        if (!hasValidRow) {
          notify("At least one certified weight entry with claims category and weight is required when Component Number is not 'na'", "error");
          return;
        }
      }

      // All validations passed, proceed to next step
      setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
    setRestrictPopUpSave(false);
  };
  const handleFinish = async () => {
    if (!TE_ID) {
      notify("TE-ID is required", "error");
      return;
    }

    const { valid, msg } = await validateNetWeightViaAPI(stepData.componentInfo, productData);
    if (!valid) {
      notify(msg, "error");
      return;
    }

    // Validate certified weight info based on component number
    const componentNo = stepData.componentInfo?.tcProductComponentNo?.toLowerCase().trim();
    const isComponentNotNa = componentNo && componentNo !== "na";

    if (isComponentNotNa) {
      const hasValidRow = stepData.standardInfo.some(
        item => item.tcProductComponentClaimsCategory && (item.tcProductComponentCertifiedWeight ?? 0) > 0
      );

      if (!hasValidRow) {
        notify("At least one certified weight entry with claims category and weight is required when Component Number is not 'na'", "error");
        return;
      }
    }

    // Get the selected Article No from stepData
    const articleNo = stepData?.componentInfo?.tcAssociatedProductNo;

    if (!articleNo) {
      notify("Please select a product Article Number", "error");
      return;
    }

    // Ensure productData is loaded - refetch if needed
    let currentProductData = productData;
    if (!currentProductData || currentProductData.length === 0) {
      console.warn("Product data not loaded, fetching...");
      try {
        const response = await executeShipment(
          TCAppConfig.GET_LIST_PRODUCT_INFO_V4,
          { tcId: TE_ID }
        );
        const productList = response?.data?.response || response?.data || [];
        currentProductData = productList;
        setProductData(productList); // Update state for future use
      } catch (err) {
        console.error("Failed to fetch product data:", err);
        notify("Failed to load product data. Please try again.", "error");
        return;
      }
    }

    // Lookup the productId and shipment info
    const shipmentData = getProductShipmentDataByProductNo(currentProductData, articleNo);
    if (!shipmentData) {
      console.error("Product lookup failed:", {
        articleNo,
        productDataLength: currentProductData?.length,
        productDataSample: currentProductData?.[0],
        availableArticleNos: currentProductData?.map((p: any) => p.tcProductArticleNo)
      });
      notify(`No shipment data found for product "${articleNo}". Please ensure the product exists and try again.`, "error");
      return;
    }

    // Validate certified weights against raw material percentages
    const validateCertifiedWeights = () => {
      if (!certifiedRawMaterialCodes.length || !tcStandardList.length) {
        console.debug("[ComponentDetails] Skipping certified weight validation - data not loaded");
        return { valid: true, msg: "" };
      }

      // Helper to check if RM is certified
      const isCertifiedRM = (code: string): boolean => {
        if (!code) return false;
        const mapping = certifiedRawMaterialCodes.find((item: any) => item.material_code === code);
        const rawStandards: string = mapping?.standard || "";
        if (!rawStandards || rawStandards.toUpperCase() === "NA") return false;
        const standards = rawStandards
          .split("/")
          .map((s: string) => s.trim())
          .filter((s: string) => s && s.toUpperCase() !== "NA");
        if (!standards.length) return false;
        const tcStandardsLower = tcStandardList.map((s) => String(s).toLowerCase());
        return standards.some((std) => tcStandardsLower.includes(std.toLowerCase()));
      };

      // Extract standard from claims category (e.g., "GRS" from "GRS - Global Recycled Standard")
      const extractStandard = (claimsCategory: string): string => {
        if (!claimsCategory) return "";
        // Extract the standard code (usually the first part before " - " or space)
        const parts = claimsCategory.split(/[\s-]/);
        return parts[0]?.trim().toUpperCase() || "";
      };

      const netShippingWeight = Number(stepData.componentInfo.tcProductComponentNetShippingWeight || 0);
      const rawMaterialInfo = stepData.rawMaterialInfo || [];
      const standardInfo = stepData.standardInfo || [];

      // Group certified weights by standard
      const weightsByStandard = new Map<string, number>();
      standardInfo.forEach((item: any) => {
        const standard = extractStandard(item.tcProductComponentClaimsCategory || "");
        if (standard) {
          const weight = Number(item.tcProductComponentCertifiedWeight || 0);
          weightsByStandard.set(standard, (weightsByStandard.get(standard) || 0) + weight);
        }
      });

      // Precompute certified raw materials and their standards
      type CertifiedRM = {
        rmCode: string;
        rmDescription: string;
        percentage: number;
        rmStandards: string[];
      };

      const certifiedRMs: CertifiedRM[] = [];

      for (const raw of rawMaterialInfo) {
        const rmCode = raw.tcProductComponentRawMaterialCode;
        if (!rmCode || !isCertifiedRM(rmCode)) {
          continue; // Skip non-certified RMs
        }

        const mapping = certifiedRawMaterialCodes.find((item: any) => item.material_code === rmCode);
        const rawStandards: string = mapping?.standard || "";
        if (!rawStandards || rawStandards.toUpperCase() === "NA") continue;

        const rmStandards = rawStandards
          .split("/")
          .map((s: string) => s.trim().toUpperCase())
          .filter((s: string) => s && s !== "NA");

        const percentage = Number(raw.tcProductComponentRawMaterialPercentage || 0);

        certifiedRMs.push({
          rmCode,
          rmDescription: raw.tcProductComponentRawMaterialCodeDescription || rmCode,
          percentage,
          rmStandards,
        });
      }

      if (!certifiedRMs.length) {
        return { valid: true, msg: "" };
      }

      // For each standard, calculate the total RM percentage that carries this standard.
      // This lets us apportion each standard's certified weight fairly across RMs
      const standardPercentageTotals = new Map<string, number>();
      certifiedRMs.forEach((rm) => {
        rm.rmStandards.forEach((std) => {
          standardPercentageTotals.set(
            std,
            (standardPercentageTotals.get(std) || 0) + rm.percentage
          );
        });
      });

      // Validate each certified raw material with apportioned weights
      for (const rm of certifiedRMs) {
        const { rmCode, rmDescription, percentage, rmStandards } = rm;

        // Calculate expected weight for this RM code
        const expectedWeight = (netShippingWeight * percentage) / 100;

        // Apportion certified weights by standard based on RM percentage share
        let sumCertifiedWeights = 0;
        rmStandards.forEach((rmStd: string) => {
          const stdWeight = weightsByStandard.get(rmStd) || 0;
          const totalPctForStd = standardPercentageTotals.get(rmStd) || 0;
          if (!stdWeight || !totalPctForStd) return;

          const share = percentage / totalPctForStd; // RM's share of this standard
          sumCertifiedWeights += stdWeight * share;
        });

        // Validate: sum of certified weights <= expected weight for this RM
        if (sumCertifiedWeights > expectedWeight + 0.01) { // Allow 0.01 tolerance for rounding
          // Build detailed breakdown of weights by standard
          const weightBreakdown: string[] = [];
          rmStandards.forEach((rmStd: string) => {
            const weight = weightsByStandard.get(rmStd) || 0;
            if (weight > 0) {
              weightBreakdown.push(`${rmStd}: ${weight.toFixed(2)} kg`);
            }
          });
          
          const excess = sumCertifiedWeights - expectedWeight;
          const weightBreakdownText = weightBreakdown.length > 0 
            ? weightBreakdown.map(w => `  - ${w}`).join(', ')
            : 'No certified weights found';
          
          return {
            valid: false,
            msg: `Certified Weight Validation Failed for Raw Material: ${rmDescription} (${rmCode}). ` +
                 `Raw Material Percentage: ${percentage}%, Component Net Shipping Weight: ${netShippingWeight.toFixed(2)} kg. ` +
                 `Expected Maximum Certified Weight: ${expectedWeight.toFixed(2)} kg, ` +
                 `Actual Certified Weights Sum: ${sumCertifiedWeights.toFixed(2)} kg. ` +
                 `Excess Weight: ${excess.toFixed(2)} kg. ` +
                 `Certified Weights by Standard: ${weightBreakdownText}. ` +
                 `Standards for this RM: [${rmStandards.join(", ")}]. ` +
                 `Please reduce the certified weights for standards [${rmStandards.join(", ")}] to not exceed ${expectedWeight.toFixed(2)} kg.`
          };
        }

        console.debug(`[ComponentDetails] Certified weight validation passed for ${rmCode}:`, {
          rmCode,
          percentage,
          expectedWeight,
          rmStandards,
          sumCertifiedWeights
        });
      }

      return { valid: true, msg: "" };
    };

    const certifiedWeightValidation = validateCertifiedWeights();
    if (!certifiedWeightValidation.valid) {
      notify(certifiedWeightValidation.msg, "error");
      return;
    }

    let newComponentId = componentId;
    const tableDataArray = Array.isArray(tableData) ? tableData : [];
    const existingComp = tableDataArray.find((comp) => comp?.componentId === componentId);

    if (!isCopy && existingComp && existingComp.tcProductComponentNo !== stepData.componentInfo.tcProductComponentNo) {
      newComponentId = null;
    }

    console.log("stepData ----> ", stepData);

    // Pass the correct productId to mapComponentData
    const payload = mapComponentData(stepData, TE_ID, shipmentData.productId, newComponentId ?? "");
    console.log("payload ----> ", payload);

    const isSuccess = await handleSave(payload);

    if (!isCopy && newComponentId !== componentId && componentId && isSuccess) {
      // if component no has been changed in edit -> delete old component silently
      setTcProductNo(existingComp?.tcProductComponentNo);
      handleConfirmSave(null, true, existingComp?.tcProductComponentNo);
    }
  };

  const actions: ActionButtonConfig[] = [
    ...activeStep !== 0 ? [{
      label: "Back",
      onClick: handleBack,
      variant: "contained" as "contained",
      color: "default" as "default",
      disabled: activeStep === 2 || activeStep === 1 ? isRestrictPopUpSave : false,
    }] : [],
    {
      label: activeStep === steps.length - 1 ? "Save" : "Next",
      onClick: activeStep === steps.length - 1 ? handleFinish : handleNext,
      variant: "contained" as "contained",
      color: "primary" as "primary",
      disabled: activeStep === 2 || activeStep === 1 ? isRestrictPopUpSave : false,
    },
  ];

  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "tcAssociatedProductArticleNo", // match API
      header: "Associated Product Article Number",
      enableHiding: false,
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "tcProductComponentNo",
      header: "Component Number",
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "tcProductComponentDetail",
      header: "Component Detail",
      minSize: 60,
      maxSize: 150,
    },
  ];
  const buildComponentSaveUrl = (
    baseUrl: string,
    teId: string,
    payload: MappedComponentPayload,
    shipmentData: any,
    opts: {
      isCopy: boolean;
      oldProductId: string | null;
      originalProductArticleNo: string | null;
    }
  ): string => {
    const currentProductId = shipmentData.productId ?? "";
    const currentArticleNo = payload.tcProductComponentInformation[0]?.tcAssociatedProductArticleNo ?? "";

    // Derive oldProductId and oldProductArticleNo per API scenarios
    const isNewComponent = !payload.componentId || payload.componentId === "";
    const oldProductIdParam = isNewComponent ? currentProductId : (opts.oldProductId ?? currentProductId);
    const oldProductArticleNoParam = isNewComponent ? currentArticleNo : (opts.originalProductArticleNo ?? currentArticleNo);

    // Scenario mapping: copy => old component new product → Yes; otherwise No
    const sameComponentNewProductCreate = opts.isCopy ? "Yes" : "No";

    const queryParams = new URLSearchParams({
      oldProductId: oldProductIdParam,
      oldProductArticleNo: oldProductArticleNoParam,
      sameComponentNewProductCreate,
    });

    return `${baseUrl}?${queryParams.toString()}`;
  };

  // Main handleSave - Handles all 4 scenarios perfectly
  const handleSave = async (payload: MappedComponentPayload) => {
    if (!TE_ID) {
      notify("TE-ID is required", "error");
      return false;
    }

    setLoadingState(true);

    // Ensure productData is loaded - refetch if needed
    let currentProductData = productData;
    const articleNo = payload.tcProductComponentInformation[0]?.tcAssociatedProductArticleNo ?? "";

    if (!currentProductData || currentProductData.length === 0) {
      console.warn("Product data not loaded in handleSave, fetching...");
      try {
        const response = await executeShipment(
          TCAppConfig.GET_LIST_PRODUCT_INFO_V4,
          { tcId: TE_ID }
        );
        const productList = response?.data?.response || response?.data || [];
        currentProductData = productList;
        setProductData(productList); // Update state for future use
      } catch (err) {
        console.error("Failed to fetch product data in handleSave:", err);
        notify("Failed to load product data. Please try again.", "error");
        setLoadingState(false);
        return false;
      }
    }

    // Find shipment info for the selected product
    const shipmentData = getProductShipmentDataByProductNo(
      currentProductData,
      articleNo
    );

    if (!shipmentData) {
      console.error("Product lookup failed in handleSave:", {
        articleNo,
        productDataLength: currentProductData?.length,
        availableArticleNos: currentProductData?.map((p: any) => p.tcProductArticleNo)
      });
      notify(`No matching shipment data found for product "${articleNo}". Please ensure the product exists and try again.`, "error");
      setLoadingState(false);
      return false;
    }

    // ========================================
    // SCENARIO DETECTION LOGIC
    // ========================================

    const isNewComponent = !payload.componentId || payload.componentId === "";
    const currentProductId = shipmentData.productId ?? "";
    const currentArticleNo =
      payload.tcProductComponentInformation[0]?.tcAssociatedProductArticleNo ?? "";

    // Check if product has changed from original
    const productChanged =
      originalProductArticleNo &&
      originalProductArticleNo !== currentArticleNo &&
      !isNewComponent;

    let oldProductIdParam = currentProductId;
    let oldProductArticleNoParam = currentArticleNo;
    let sameComponentNewProductCreate = "No";
    let scenario = "";

    // ========================================
    // DETERMINE SCENARIO
    // ========================================

    if (isNewComponent) {
      // SCENARIO 1: New Component + New Product
      oldProductIdParam = currentProductId;
      oldProductArticleNoParam = currentArticleNo;
      sameComponentNewProductCreate = "No";
      scenario = "New Component";

    } else if (isCopy) {
      // SCENARIO 2: Old Component + New Product (Copy to different/same product)
      oldProductIdParam = currentProductId;
      oldProductArticleNoParam = currentArticleNo;
      sameComponentNewProductCreate = "Yes";
      scenario = "Copy Component";

    } else if (!productChanged) {
      // SCENARIO 3: Old Component + Old Product (Edit same component on same product)
      oldProductIdParam = productId ?? currentProductId;
      oldProductArticleNoParam = originalProductArticleNo ?? currentArticleNo;
      sameComponentNewProductCreate = "No";
      scenario = "Edit Same Component";

    } else {
      // SCENARIO 4: Old Component + Different Product (Edit component and change product)
      oldProductIdParam = productId ?? currentProductId;
      oldProductArticleNoParam = originalProductArticleNo ?? currentArticleNo;
      sameComponentNewProductCreate = "No";
      scenario = "Edit Component with Product Change";
    }



    // ========================================
    // BUILD FINAL URL WITH QUERY PARAMETERS
    // ========================================

    // Ensure oldProductArticleNo is properly set from tcAssociatedProductNo
    const safeOldArticleNo = oldProductArticleNoParam || currentArticleNo || "";

    const queryParams = new URLSearchParams({
      oldProductId: oldProductIdParam,
      oldProductArticleNo: safeOldArticleNo,
      sameComponentNewProductCreate,
    });

    const finalUrl = `${TCAppConfig.COMPONENT_DETAILS_ENDPOINT_V4}?${queryParams.toString()}`;

    console.log("Final URL:", finalUrl);
    console.log("Query Params - oldProductArticleNo:", safeOldArticleNo);
    console.log("Scenario:", scenario);

    // ========================================
    // BUILD CLEAN PAYLOAD (Only required fields from API docs)
    // ========================================

    const cleanPayload = {
      tcId: TE_ID,
      productId: shipmentData.productId,
      ...(isNewComponent ? {} : { componentId: payload.componentId }),
      tcProductComponentInformation: payload.tcProductComponentInformation.map((info: any) => ({
        tcAssociatedProductArticleNo: info.tcAssociatedProductArticleNo ?? "",
        tcProductComponentNo: info.tcProductComponentNo ?? "",
        tcProductComponentDetail: info.tcProductComponentDetail ?? "",
        tcProductComponentInfoFiberLength: info.tcProductComponentInfoFiberLength ?? "",
        tcProductComponentInfoYarnCount: info.tcProductComponentInfoYarnCount ?? "",
        tcProductComponentInfoFabricWeightAndConstruct:
          info.tcProductComponentInfoFabricWeightAndConstruct ?? "",
        tcProductComponentInfoFabricWeightOfFinishedProduct:
          info.tcProductComponentInfoFabricWeightOfFinishedProduct ?? "",
        tcProductComponentNetShippingWeight: info.tcProductComponentNetShippingWeight ?? 0,
        tcProductComponentInfoAdditional: info.tcProductComponentInfoAdditional ?? "",
        tcProductComponentInfoTechnicalSpecifications:
          info.tcProductComponentInfoTechnicalSpecifications ?? "",

        // Ensure arrays always have at least one object
        tcProductComponentCertifiedWeightInformation:
          info.tcProductComponentCertifiedWeightInformation &&
            info.tcProductComponentCertifiedWeightInformation.length > 0
            ? info.tcProductComponentCertifiedWeightInformation
            : [
              {
                tcProductComponentClaimsCategory: " ",
                tcProductComponentClaimsCategoryDescription: "",
                tcProductComponentCertifiedWeight: 0,
              },
            ],

        tcProductComponentRawMaterialInformation:
          info.tcProductComponentRawMaterialInformation &&
            info.tcProductComponentRawMaterialInformation.length > 0
            ? info.tcProductComponentRawMaterialInformation
            : [
              {
                tcProductComponentRawMaterialPercentage: 0,
                tcProductComponentRawMaterialCode: "",
                tcProductComponentRawMaterialCodeDescription: "",
              },
            ],
      })),
    };

    console.log("Clean Payload:", cleanPayload);
    console.log("Scenario:", scenario);

    // ========================================
    // EXECUTE API CALL
    // ========================================

    try {
      const result = await executePost(finalUrl, cleanPayload);
      setLoadingState(false);

      if (result?.status === 200) {
        notify(`Data Saved Successfully`, "success");

        // Reset drawer and state
        await onNextTab();
        toggleDrawer();
        fetchComponentDetails();
        setStepData({
          componentInfo: initComponentInfo,
          standardInfo: initStandardInfo,
          rawMaterialInfo: initRawMaterialInfo,
        });
        setComponentId(null);
        setIsValueChanged(false);
        setIsDeleteOnly(false);
        return true;
      } else {
        notify("Unable to Save", "error");
        setLoadingState(false);
        return false;
      }
    } catch (err: any) {
      console.error(`Error saving component in ${scenario}:`, err);
      setLoadingState(false);
      notify(err?.message || "Failed to save component", "error");
      return false;
    }
  };

  const onEdit = (row: any) => {
    setIsEdit(true);
    setIsCopy(false)
    const value = row?.original as Component;
    setComponentId(value.componentId);
    setShipmentId(value.shipmentId);
    setProductId(value.productId);
    setOriginalProductArticleNo(value.tcAssociatedProductArticleNo);
    setIsCopy(false);
    setIsValueChanged(false);
    if (TE_ID) {
      fetchaddComponentDetails(
        executeaddGet,
        TE_ID,
        value.shipmentId,
        value.productId,
        value.componentId
      )
        .then((data) => {
          const productList = data?.data?.tcProductComponentInformation;

          if (productList && productList.length > 0) {
            const product = productList[0];
            console.log("product", product);
            const mappedStepData = mapToApiComponentData(product);
            console.log("mappedStepData", mappedStepData);

            const filteredStepData = {
              componentInfo: mappedStepData.componentInfo,
              rawMaterialInfo: mappedStepData.rawMaterialInfo.filter(
                (item: any) =>
                  !(
                    item.tcProductComponentRawMaterialCode === "" &&
                    item.tcProductComponentRawMaterialPercentage === 0 &&
                    item.tcProductComponentRawMaterialCodeDescription === ""
                  )
              ),
              standardInfo: mappedStepData.standardInfo.filter(
                (item: any) =>
                  !(
                    item.tcProductComponentClaimsCategory.trim() === "" &&
                    item.tcProductComponentClaimsCategoryDescription === "" &&
                    item.tcProductComponentCertifiedWeight === 0
                  )
              ),
            };

            setStepData(filteredStepData);
            if (!originalProductArticleNo) {
              setOriginalProductArticleNo(stepData.componentInfo.tcAssociatedProductNo);
            }
          }

          // Open the drawer after fetching and mapping data
          toggleDrawer();
        })
        .catch((err) => notify(err.message, "error"));
    }

    // Set additional state
    setEditingIndex(row.index);
    setZustandInitialState(value);
  };

  const onCopy = (row: any) => {
    const value = row?.original as Component;
    setComponentId(value.componentId);
    setShipmentId(value.shipmentId);
    setProductId(value.productId);
    setOriginalProductArticleNo(value.tcAssociatedProductArticleNo);
    setIsCopy(true);
    setIsEdit(false);
    if (TE_ID) {
      fetchaddComponentDetails(
        executeaddGet,
        TE_ID,
        value.shipmentId,
        value.productId,
        value.componentId
      )
        .then((data) => {
          const productList = data?.data?.tcProductComponentInformation;
          if (productList && productList.length > 0) {
            const product = productList[0];
            const mappedStepData = mapToApiComponentData(product);

            const filteredStepData = {
              componentInfo: mappedStepData.componentInfo,
              rawMaterialInfo: mappedStepData.rawMaterialInfo.filter(
                (item: any) =>
                  !(
                    item.tcProductComponentRawMaterialCode === "" &&
                    item.tcProductComponentRawMaterialPercentage === 0 &&
                    item.tcProductComponentRawMaterialCodeDescription === ""
                  )
              ),
              standardInfo: mappedStepData.standardInfo.filter(
                (item: any) =>
                  !(
                    item.tcProductComponentClaimsCategory.trim() === "" &&
                    item.tcProductComponentClaimsCategoryDescription === "" &&
                    item.tcProductComponentCertifiedWeight === 0
                  )
              ),
            };

            setStepData(filteredStepData);
          }
          toggleDrawer();
        })
        .catch((err) => notify(err.message, "error"));
    }
    setEditingIndex(row.index);
  };

  const onDelete = (row: any) => {
    const tcProductComponentNo = row?.original?.tcProductComponentNo;
    const productId = row?.original?.productId;
    const productArticleNo = row?.original?.tcAssociatedProductArticleNo
    setTcProductNo(tcProductComponentNo);
    setProductId(productId);
    setShipmentId(row?.original?.shipmentId);
    setComponentId(row?.original?.componentId);
    setOriginalProductArticleNo(productArticleNo)
    setIsDeleteOnly(true);

    setDialogOpen(true);
    setPopUpBtnName("Yes");
    setPopUpTitle("Confirm Delete ?");
    setPopUpMessage(`Deleting Component Number ${tcProductComponentNo} will remove all the Associated Records, are you sure want to Delete it`);
  };

  const onEditDelete = (row: any) => {
    const tcProductComponentNo = row?.original?.tcProductComponentNo;
    const productId = row?.original?.productId;
    setTcProductNo(tcProductComponentNo);
    setProductId(productId);
    setShipmentId(row?.original?.shipmentId);
    setComponentId(row?.original?.componentId);
    setIsDeleteOnly(false);

    setDialogOpen(true);
    setPopUpBtnName("Save");
    setPopUpTitle("Confirm Save ?");
    setPopUpMessage(
      `Editing Component Number ${tcProductComponentNo} will remove all the Associated Records, are you sure want to edit it`
    );
  };
  const handleNavigate = async () => {
    navigate(`/v4/tc/${formtype}/incoming-tc-details/${TE_ID}`);
  };
  const handleConfirmSave = async (
    e: any = null,
    isSilent = false,
    compNo: string | null | undefined = null
  ) => {
    try {
      // Only execute delete if this is a delete operation
      if (isDeleteOnly) {
        const res = await executeDelete(`${TCAppConfig.TC_DELETE_API_V4}`, {
          tcId: TE_ID,
          productId: productId,
          componentId: componentId,
          componentNo: tcProductComponentNo,
          productArticleNo: originalProductArticleNo,
        });

        if (res?.status === 200) {
          setDialogOpen(false);
          setComponentId(null);
          setProductId(null);
          setShipmentId(null);
          setOriginalProductArticleNo(null);
          setTcProductNo(null);
          setIsDeleteOnly(false);
          fetchComponentDetails();
          if (!isSilent) {
            notify("Successfully processed", "success");
          }
        }
      } else {
        // This was an edit confirmation, just close the dialog
        setDialogOpen(false);
      }
    } catch (error) {
      console.error("Error in handleConfirmSave:", error);
      notify("Failed to process the request", "error");
    }
  };
  const handleCancelSave = () => {
    setDialogOpen(false);
    setIsDeleteOnly(false);
    if (drawerOpen) {
      toggleDrawer();
    }
  };
  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
            {!(hasSubmitTc) && (
              <StyledButton variant="contained" onClick={toggleDrawer}>
                Add Component Information
              </StyledButton>
            )}
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={tableData}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableRowActions={!hasSubmitTc}
              rowCount={rowCount}
              paginations={pagination}
              setPaginations={setPagination}
              renderDetailPanel={({ row }) =>
                // Only mount the detail panel if the row is expanded
                row.getIsExpanded() ? (
                  <RenderDetailPanel row={row} />
                ) : (
                  <>NO data</>
                )
              }
              renderRowActions={({ row }) => (
                <ActionsMenu
                  row={row}
                  onEdit={onEdit}
                  onDelete={onDelete}
                // onCopy={onCopy}
                />
              )}
            />
          </Box>
          <ActionsModalPopup
            open={drawerOpen}
            onClose={toggleDrawer}
            title={isEdit ? "Edit Component" : "Add Component"}
            actions={actions}
          >
            <CustomStepper
              steps={steps}
              activeStep={activeStep}
              onStepChange={handleStepChange}
            />
          </ActionsModalPopup>

          {!drawerOpen ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                gap: "0.5rem",
              }}
            >
              {/* {!isNextEnabled && <InnerButton onClick={handleSave}>Save & Next</InnerButton>} */}
              <NavLink to="/v4/tc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>
              <NavLink to={`/v4/tc/${formtype}/product-details/${TE_ID}`}>
                <InnerButton>Back</InnerButton>
              </NavLink>
              {tableData?.length > 0 && (
                <InnerButton onClick={handleNavigate}>Next</InnerButton>
              )}
            </Box>
          ) : (
            <>
              {TE_ID && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 2,
                    gap: "0.5rem",
                  }}
                >
                  {hasSubmitTc && (
                    <NavLink to={`/v4/tc/${formtype}/product-details/${TE_ID}`}>
                      <InnerButton>Back</InnerButton>
                    </NavLink>
                  )}
                  <InnerButton onClick={handleNavigate}>Next</InnerButton>
                </Box>
              )}
            </>
          )}

          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />
        </>
      )}
    </>
  );
};

export default ComponentDetails;
